import { Card } from '../../molecules/card/card.js';
import { jsx } from 'react/jsx-runtime';

function SliderItem(props) {
  return /*#__PURE__*/jsx(Card, {
    ...props,
    layout: "slider",
    locationInSlider: props.locationInSlider,
    mountIn: props.containerRef.current ?? undefined
  });
}

export { SliderItem };
//# sourceMappingURL=item.js.map
